<div id="layout" class="admin_payments f_col no_max_size">
  <app-view-title class="" fromRoute="pre-enroll" [chooseLangBtn]="false">{{'menu.requests.DYN.' | translate}}</app-view-title>
  <app-table #smartTable *ngIf="config" class="userSmartTable"
    [config]="config"
    [initialConfig]="initialConfig"
    [dataTransformer]="tableDataTransformer"
    [serverItemCount]="totalCount"
    [topButtons]="topButtons"
    [overrideFunctions]="filterOverrideFunctions"
    (onRowClick)="navigateWithParams($event)"
    (onQueryChange)="onQueryChange($event)"
    (onLoadingStateChange)="onLoadingStateChange($event)">
  </app-table>
  <div class="btns-container resp_maxSize_l mb_20">
    <app-back-btn icon="house" [navTo]="{route: 'dashboard'}"></app-back-btn>
  </div>
</div>
